import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "w-full pb-8" }
const _hoisted_2 = { class: "text-xl text-center my-2" }
const _hoisted_3 = { class: "text-base text-lighterDark mb-3" }
const _hoisted_4 = {
  key: 0,
  class: "mt-5 grid gap-3"
}

import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { IonIcon } from '@ionic/vue'
import CalendarAddButton from '@/components/Calendar/AddButton.vue'
import { OrderReservation } from '@/models/order'


export default /*#__PURE__*/_defineComponent({
  __name: 'AddToCalendar',
  props: {
    order: { default: undefined }
  },
  setup(__props: any) {

const props = __props;



const googleLogo = computed(() => require('@/assets/google-logo.svg'))
const appleLogo = computed(() => require('@/assets/apple-logo.svg'))
const microsoftLogo = computed(() => require('@/assets/microsoft-logo.svg'))
const { t } = useI18n()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(IonIcon), {
      src: require('@/assets/calendar-plus.svg'),
      class: "gw-main-icon text-[3rem] text-primary mx-auto block"
    }, null, 8, ["src"]),
    _createElementVNode("h3", _hoisted_2, [
      _createElementVNode("span", null, _toDisplayString(_unref(t)('order.reservation.calendar.title')), 1)
    ]),
    _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(t)('order.reservation.calendar.description')), 1),
    (props.order)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(CalendarAddButton, {
            "calendar-type": "Google",
            title: _unref(t)('order.reservation.calendar.google.title'),
            order: props.order,
            description: _unref(t)('order.reservation.calendar.google.description'),
            logo: googleLogo.value
          }, null, 8, ["title", "order", "description", "logo"]),
          _createVNode(CalendarAddButton, {
            "calendar-type": "iCal",
            title: _unref(t)('order.reservation.calendar.apple.title'),
            order: props.order,
            description: _unref(t)('order.reservation.calendar.apple.description'),
            logo: appleLogo.value
          }, null, 8, ["title", "order", "description", "logo"]),
          _createVNode(CalendarAddButton, {
            "calendar-type": "Outlook.com",
            title: _unref(t)('order.reservation.calendar.outlook.title'),
            order: props.order,
            description: _unref(t)('order.reservation.calendar.outlook.description'),
            logo: microsoftLogo.value
          }, null, 8, ["title", "order", "description", "logo"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})